import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule],
})
export class TextInputComponent {
    @Input() placeholder: string = '';
    @Input() value: string = '';
    @Input() disabled: boolean = false;
    @Input() helperText: string = '';
    @Input() startIcon: string = '';
    @Input() width: string = '100%';
    @Input() hasError: boolean = false;
    @Output() valueChange = new EventEmitter<string>();
    isFloating: boolean = false;

    onFocus(): void {
        this.isFloating = true;
    }

    onBlur(): void {
        this.isFloating = !!this.value;
    }

    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.value = input.value.trim();
        this.valueChange.emit(this.value);
    }

    clearInput(): void {
        this.value = '';
        this.isFloating = false;
        this.valueChange.emit(this.value);
    }
}
